// extracted by mini-css-extract-plugin
export default {"container":"location-address_container__3Uoj3","title":"location-address_title__2jhxe","button":"location-address_button__TZRWx","icon":"location-address_icon__3f8wE"};